import { gql } from "urql";

export const MUTATION_CREATE_NEW_TASK: any = gql(`
    mutation CreateNewTask($createNewTaskInput: CreateNewTaskInput!) {
        CreateNewTask(createNewTaskInput: $createNewTaskInput) {
            _id
            name
        }
    }
`)

export const MUTATION_CREATE_LOAN_DOC: any = gql(`
    mutation CreateLoanDoc($createLoanDocInput: CreateLoanDocInput!) {
        CreateLoanDoc(createLoanDocInput: $createLoanDocInput) {
            _id
            name
        }
    }
`)

export const MUTATION_CREATE_LOAN_CLOSED: any = gql(`
    mutation CreateLoanClosed($createLoanClosedInput: CreateLoanClosedInput!) {
        createLoanClosed(createLoanClosedInput: $createLoanClosedInput) {
            _id
            state
        }
    }
`)

export const MUTATION_DELETE_FILE_LOAN_DOC: any = gql(`
    mutation DeleteFileLoanDoc($fileKey: String!, $loanDocId: String, $multipleFiles: Boolean) {
        DeleteFileLoanDoc(fileKey: $fileKey, loanDocId: $loanDocId, multipleFiles: $multipleFiles) {
            _id
        }
    }
`)

export const MUTATION_DELETE_LOAN_DOCUMENT: any = gql(`
    mutation DeleteLoanDocument($loanDocId: String, $fileKey: String) {
        DeleteLoanDocument(loanDocId: $loanDocId, fileKey: $fileKey)
    }
`)